import Swal from "sweetalert2";
const openForms = new Set();
let openPrompt = null;
export function registerUnsavedForm(form) {
    openForms.add(form);
    return () => {
        openForms.delete(form);
    };
}
export function hasUnsavedChanges() {
    return Array.from(openForms).some((form) => form.hasUnsavedChanges());
}
// After the user agreed to discard, so the navigation that follows doesn't ask again
export function discardUnsavedChanges() {
    openForms.forEach((form) => form.skipUnsavedCheck());
}
// Resolves true when the user chooses to discard. A second request while the dialog is open shares it.
export function askToDiscardChanges() {
    if (!openPrompt) {
        openPrompt = Swal.fire({
            customClass: {
                container: "remove-swal2-container",
                title: "remove-swal2-title",
                popup: "remove-swal2-popup",
                icon: "remove-swal2-icon",
            },
            title: "Discard unsaved changes?",
            text: "You have unsaved changes. If you leave now, they will be lost.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f46a6a",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Discard",
            cancelButtonText: "Keep editing",
        }).then((result) => {
            openPrompt = null;
            return !!result.value;
        });
    }
    return openPrompt;
}
